export default __webpack_public_path__ + "static/media/cc_tan.35c2b6dc.jpg";